import React from 'react';
// import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import { Actions as ActionsSnapshot } from '../../ducks/snapshots';
import { Actions as ActionsMarket } from '../../ducks/markets';

import { Blocker, MarketsContainer } from './components';
// import makeMergeData from './selector';

const { observeSnapshots } = ActionsSnapshot.thunks;
const { fetchMarkets } = ActionsMarket.thunks;

class Markets extends React.PureComponent {
  componentDidMount() {
    this.props.fetchMarkets();
    if (this.props.currentUser && this.props.currentUser.active) {
      this.props.observeSnapshots('b');
    }
  }

  componentWillUnmount() {
    console.log('Unmounted!!!');
    ActionsSnapshot.removeObserver();
  }

  render() {
    const { currentUser } = this.props;
    const active = !currentUser || !currentUser.active;
    if (!active) {
      return <MarketsContainer />;
    }
    return (
      <Blocker>
        <MarketsContainer />
      </Blocker>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
    // results: makeMergeData(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchMarkets,
      observeSnapshots,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Markets);



// WEBPACK FOOTER //
// ./src/containers/Markets/index.jsx